import { Component, effect, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { settingStore } from '@core/store/index';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';


@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: true,
  styleUrl: './app.css',
  imports: [
    RouterOutlet,
    ToastModule,
    ButtonModule,
    BadgeModule,
    AvatarModule
  ]
})
export class App {
  protected readonly title = signal('condopal');
  settingStore = inject(settingStore);

  constructor(private translate: TranslateService) {
    // El idioma inicial ya se cargó en provideAppInitializer (app.config.ts).
    // Este effect solo reacciona a cambios posteriores desde el store.
    effect(() => {
      const currentLang = this.settingStore.data.language();
      if (this.translate.getCurrentLang() !== currentLang) {
        this.translate.use(currentLang);
      }
    });
  }
}
